export default {
    name: "formatting",
    methods: {
        roundToDecimal(num, dec) {
            let multiplier = Math.pow(10, dec);
            return Math.round(num * multiplier) / multiplier;
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/formatting.js